import { FaqPage } from '@/features/faq-page/type';

export function buildFaqPageUrl(page: FaqPage): string {
  return ['', ..._faqPageNesting(page)].join('/');
}

function _faqPageNesting(node: FaqPage | null): string[] {
  if (!node) return [];

  return [..._faqPageNesting(node.parent), node.slug];
}
